import type { Runner } from '@ps/isp-web-services-types';
import classNames from 'clsx';
import React from 'react';

import styles from './RunnerDetails.scss';

interface Props {
  runner: Runner;
  labelClassName: string;
  children: React.ReactElement;
}

const RunnerDetails: React.FC<Props> = ({ runner, labelClassName, children }) => (
  <div className={classNames(styles.selection)}>
    <span className={labelClassName}>{runner.runnerName}</span>
    {children}
  </div>
);

export default RunnerDetails;
